export interface KeycloakConfig {
  url: string;
  realm: string;
  clientId: string;
}

export const keycloakConfig: Record<string, KeycloakConfig> = {
  production: {
    url: 'https://id.containerize.app',
    realm: 'omrquiz-app',
    clientId: 'aspose-omrquiz-app-client'
  },
  qa: {
    url: 'https://app-idp.svc.k8s.dynabic.com', // Fixed: was 'idp', should be 'app-idp' like Formize
    realm: 'omrquiz-app',
    clientId: 'aspose-omrquiz-app-client-qa'
  },
  local: {
    url: 'https://app-idp.svc.k8s.dynabic.com', // Fixed: was 'idp', should be 'app-idp' like Formize
    realm: 'omrquiz-app',
    clientId: 'aspose-omrquiz-app-client-qa' // Using QA client for local development
  }
};

/**
 * Get Keycloak configuration based on environment
 * Environment is determined by REACT_APP_ENV variable or current hostname
 */
export function getKeycloakConfig(): KeycloakConfig {
  // Check environment variable first
  const env = process.env.REACT_APP_ENV;
  
  if (env && keycloakConfig[env]) {
    console.log(`[Keycloak Config] Using environment: ${env}`);
    return keycloakConfig[env];
  }

  // Fallback to hostname detection
  const hostname = window.location.hostname;
  
  if (hostname === 'panel.omrquiz.app' || hostname === 'dashboard.omrquiz.app') {
    console.log('[Keycloak Config] Detected production hostname');
    return keycloakConfig.production;
  }
  
  if (hostname === 'panel.qa.omrquiz.app' || hostname === 'dashboard.qa.omrquiz.app') {
    console.log('[Keycloak Config] Detected QA hostname');
    return keycloakConfig.qa;
  }
  
  // Default to local/QA for localhost
  console.log('[Keycloak Config] Using local/QA environment');
  return keycloakConfig.local;
}

